'use strict';
'use client';
import { j as a } from "../../external/react/jsx-runtime.js";
import r from "./usp-bar.module.scss.js";
import x from "../../external/classnames/index.js";
import { FontAwesomeIcon as i } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { useClientRect as l } from "../../hooks/useWindowDimensions.js";
import "react";
import "../../external/js-cookie/dist/js.cookie.js";
function b({ items: c, className: m }) {
  const [o, d] = l(), [t, p] = l(), n = t && o ? t.width > o.width : !1;
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      ref: d,
      className: x(r["usp-bar"], m),
      "data-animated": n,
      children: [
        /* @__PURE__ */ a.jsx("div", { ref: p, className: r["usp-bar__track"], children: c.map((s, e) => /* @__PURE__ */ a.jsxs("div", { className: r["usp-bar__item"], children: [
          /* @__PURE__ */ a.jsx(
            i,
            {
              size: "xl",
              icon: s.icon,
              className: s.color
            }
          ),
          /* @__PURE__ */ a.jsx("p", { className: s.color, children: s.text })
        ] }, e)) }),
        n ? /* @__PURE__ */ a.jsx("div", { className: r["usp-bar__track"], "aria-hidden": !0, children: c.map((s, e) => /* @__PURE__ */ a.jsxs("div", { className: r["usp-bar__item"], children: [
          /* @__PURE__ */ a.jsx(
            i,
            {
              size: "xl",
              icon: s.icon,
              className: s.color
            }
          ),
          /* @__PURE__ */ a.jsx("p", { className: s.color, children: s.text })
        ] }, e)) }) : null
      ]
    }
  );
}
export {
  b as default
};
